export default __webpack_public_path__ + "static/media/Hyrmax_hero_sm.fcb41809.jpg";